/* WrapPrinting.com theme scripts */
(function () {
  'use strict';
  var WP = window.WP || {};

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var fmt = WP.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  function num(el) { if (!el) return 0; var v = parseFloat(el.value); return isFinite(v) && v > 0 ? v : 0; }
  function fmtInt(n) { return Number(n).toLocaleString('en-US'); }
  function fmt1(n) { var r = Math.round(n * 10) / 10; return r.toLocaleString('en-US', { maximumFractionDigits: 1 }); }
  function fmtIn(n) { return String(Math.round(n * 100) / 100); }

  /* ---------- material layout ----------
     Bills the vinyl run through the printer. R = billed roll width, P = max printable width per panel.
     If the graphic fits across the roll one way, it prints in one piece (copies nest side by side).
     If both sides are wider than P, it is split into panels in whichever direction uses less vinyl. */
  function orient(across, len, n, P) {
    if (across <= P + 1e-9) {
      var perRow = Math.max(1, Math.min(n, Math.floor((P + 1e-9) / across)));
      var rows = Math.ceil(n / perRow);
      return { across: across, len: len, panels: 1, perRow: perRow, rows: rows, run: rows * len };
    }
    var panels = Math.ceil(across / P - 1e-9);
    return { across: across, len: len, panels: panels, perRow: 1, rows: n, run: panels * len * n };
  }
  function materialLayout(w, h, n, R, P) {
    if (!(w > 0 && h > 0 && R > 0)) return null;
    n = Math.max(1, Math.round(n) || 1);
    P = Math.min(P > 0 ? P : R, R);
    var a = orient(w, h, n, P), b = orient(h, w, n, P);
    var aFits = a.panels === 1, bFits = b.panels === 1, best;
    if (aFits && !bFits) best = a;
    else if (bFits && !aFits) best = b;
    else best = (b.run < a.run - 1e-9 || (Math.abs(b.run - a.run) < 1e-9 && b.panels < a.panels)) ? b : a;
    best.rotated = best === b && w !== h;
    best.billedSqIn = R * best.run;
    best.artSqIn = w * h * n;
    return best;
  }
  function layoutNote(L, R, P) {
    var parts = [];
    if (L.panels > 1) parts.push(L.panels + ' panels per copy (' + fmtIn(P) + '" max print width)');
    else if (L.perRow > 1) parts.push(L.perRow + ' across the roll, ' + L.rows + ' row' + (L.rows === 1 ? '' : 's'));
    else parts.push(L.rows > 1 ? L.rows + ' copies, one per row' : '1 panel');
    parts.push(fmtIn(R) + '" x ' + fmtIn(L.run) + '" of vinyl = ' + fmt1(L.billedSqIn / 144) + ' sq ft');
    return parts.join(' \u00b7 ');
  }
  WP.materialLayout = materialLayout;
  /* Billed square feet: whole square feet, rounded up. Shared by both calculators. */
  function billedSqft(billedSqIn) { return billedSqIn > 0 ? Math.ceil(billedSqIn / 144 - 1e-9) : 0; }

  /* ---------- volume tiers ---------- */
  function tierState(sqft) {
    var tiers = (WP.tiers || []).filter(function (t) { return t.sqft > 0 && t.pct > 0; })
      .sort(function (a, b) { return a.sqft - b.sqft; });
    var current = null, next = null;
    tiers.forEach(function (t) { if (sqft >= t.sqft) current = t; else if (!next) next = t; });
    return { tiers: tiers, current: current, next: next };
  }
  function tierMessage(sqft) {
    if (!WP.showTiers) return '';
    var state = tierState(sqft), tiers = state.tiers;
    if (!tiers.length || sqft <= 0) return '';
    var current = state.current, next = state.next;
    if (current && !next) return current.pct + '% volume discount applies at checkout.';
    if (current && next) return current.pct + '% off applies. Add ' + fmtInt(next.sqft - sqft) + ' sq ft more for ' + next.pct + '% off.';
    if (next && sqft >= next.sqft * 0.5) return 'Add ' + fmtInt(next.sqft - sqft) + ' sq ft more to save ' + next.pct + '% (' + fmtInt(next.sqft) + '+ sq ft per order).';
    if (next) return 'Volume pricing starts at ' + fmtInt(next.sqft) + ' sq ft per order (' + next.pct + '% off, applied automatically).';
    return '';
  }

  /* ---------- ship date ---------- */
  function pacificParts(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', hour12: false, weekday: 'short'
    }).formatToParts(date);
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, wd: o.weekday };
  }
  function isWeekend(dt) { var w = dt.getUTCDay(); return w === 0 || w === 6; }
  function addBusinessDays(dt, n) {
    var d = new Date(dt.getTime());
    while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (!isWeekend(d)) n--; }
    return d;
  }
  function labelDay(dt) { return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }); }
  function shipDateText() {
    try {
      var now = pacificParts(new Date());
      var approve = new Date(Date.UTC(now.y, now.m - 1, now.d, 12));
      var cutoff = Number(WP.cutoffHour) || 12;
      var sameDay = !isWeekend(approve) && now.h < cutoff;
      if (!sameDay) { do { approve.setUTCDate(approve.getUTCDate() + 1); } while (isWeekend(approve)); }
      var ship = addBusinessDays(approve, Number(WP.turnaroundDays) || 2);
      var cutoffLabel = cutoff === 12 ? 'noon' : (cutoff > 12 ? (cutoff - 12) + ' pm' : cutoff + ' am');
      var when = sameDay ? 'today' : labelDay(approve);
      return 'Approve your proof by ' + cutoffLabel + ' PT ' + when + ' and it ships ' + labelDay(ship) + '.';
    } catch (e) { return ''; }
  }
  document.querySelectorAll('[data-ship-date]').forEach(function (el) {
    var text = shipDateText();
    var span = el.querySelector('span');
    if (text && span) span.textContent = text;
  });

  /* ---------- mobile nav ---------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var nav = document.querySelector('.site-nav');
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- product page ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]') || root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var variantsEl = form.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = form.querySelector('[data-variant-id]');
    var qtyInput = form.querySelector('[data-qty]');
    var priceEl = root.querySelector('[data-price] .sqft-price__amount');
    var addBtn = form.querySelector('[data-add]');
    var calc = form.querySelector('[data-calc]');
    var simpleQty = form.querySelector('[data-simple-qty]');

    /* gallery thumbs */
    var mainWrap = root.querySelector('[data-main-media]');
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = mainWrap && mainWrap.querySelector('img');
        if (!img) return;
        img.src = btn.getAttribute('data-src');
        img.srcset = btn.getAttribute('data-srcset');
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    /* variants */
    function currentVariant() {
      var id = Number(idInput.value);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }
    function onOptionChange() {
      var selected = [];
      form.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected[Number(fs.getAttribute('data-option-index'))] = checked ? checked.value : null;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] == null || opt === selected[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (calc) calc.setAttribute('data-price', match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Unavailable';
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (calc) updateCalc();
    }
    form.querySelectorAll('[data-option-input]').forEach(function (inp) { inp.addEventListener('change', onOptionChange); });

    /* simple quantity (non-sq-ft products) */
    if (simpleQty && qtyInput) {
      var syncQty = function () { qtyInput.value = Math.max(1, Math.round(num(simpleQty)) || 1); };
      simpleQty.addEventListener('input', syncQty); syncQty();
    }

    /* square-foot calculator: bills the vinyl run through the printer */
    function updateCalc() {
      if (!calc) return 0;
      var R = Number(calc.getAttribute('data-roll-width')) || 60;
      var P = Number(calc.getAttribute('data-print-width')) || R;
      var price = Number(calc.getAttribute('data-price')) || currentVariant().price;
      var billedSqIn = 0, artSqIn = 0, run = 0, sizes = [];
      calc.querySelectorAll('[data-calc-row]').forEach(function (row) {
        var w = num(row.querySelector('[data-calc-width]'));
        var h = num(row.querySelector('[data-calc-height]'));
        var n = Math.max(1, Math.round(num(row.querySelector('[data-calc-copies]'))) || 1);
        var note = row.querySelector('[data-calc-row-note]');
        var L = materialLayout(w, h, n, R, P);
        if (!L) { if (note) note.hidden = true; return; }
        billedSqIn += L.billedSqIn; artSqIn += L.artSqIn; run += L.run;
        sizes.push(fmtIn(w) + ' x ' + fmtIn(h) + ' in (' + n + (n === 1 ? ' copy' : ' copies') + ')');
        if (note) { note.textContent = layoutNote(L, R, P); note.hidden = false; }
      });
      var sqft = billedSqft(billedSqIn);

      calc.querySelector('[data-calc-art]').textContent = fmt1(artSqIn / 144) + ' sq ft';
      calc.querySelector('[data-calc-sqft]').textContent = fmtInt(sqft) + ' sq ft';
      calc.querySelector('[data-calc-total-price]').textContent = formatMoney(sqft * price);
      if (qtyInput) qtyInput.value = Math.max(1, sqft);

      var pSizes = calc.querySelector('[data-prop-sizes]'), pMat = calc.querySelector('[data-prop-material]'),
          pSq = calc.querySelector('[data-prop-sqft]');
      if (pSizes) { pSizes.disabled = !sqft; pSizes.value = sizes.join('; '); }
      if (pMat) { pMat.disabled = !sqft; pMat.value = fmtIn(R) + ' in roll x ' + fmtIn(run) + ' in run (' + fmt1(run / 12) + ' ft)'; }
      if (pSq) pSq.value = sqft > 0 ? String(sqft) : '';

      var tierEl = calc.querySelector('[data-calc-tier]');
      var msg = tierMessage(sqft);
      if (tierEl) { tierEl.textContent = msg; tierEl.hidden = !msg; }

      if (sqft > 0) { calc.classList.remove('is-error'); var err = calc.querySelector('.calc__error'); if (err) err.remove(); }
      return sqft;
    }
    if (calc) {
      var rowsWrap = calc.querySelector('[data-calc-rows]');
      var addRowBtn = calc.querySelector('[data-calc-add]');
      var MAX_ROWS = 12;
      var rowTemplate = rowsWrap.querySelector('[data-calc-row]').cloneNode(true);
      var renumber = function () {
        var rows = rowsWrap.querySelectorAll('[data-calc-row]');
        rows.forEach(function (row, i) {
          var head = row.querySelector('[data-calc-row-head]');
          var title = row.querySelector('[data-calc-row-title]');
          if (head) head.hidden = rows.length < 2;
          if (title) title.textContent = 'Size ' + (i + 1);
        });
        if (addRowBtn) addRowBtn.hidden = rows.length >= MAX_ROWS;
      };
      if (addRowBtn) addRowBtn.addEventListener('click', function () {
        var row = rowTemplate.cloneNode(true);
        row.querySelectorAll('input').forEach(function (inp) { inp.value = inp.hasAttribute('data-calc-copies') ? '1' : ''; });
        rowsWrap.appendChild(row);
        renumber();
        var first = row.querySelector('[data-calc-width]');
        if (first) first.focus();
        updateCalc();
      });
      calc.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-calc-remove]');
        if (!btn) return;
        var row = btn.closest('[data-calc-row]');
        if (row && rowsWrap.querySelectorAll('[data-calc-row]').length > 1) row.remove();
        renumber();
        updateCalc();
      });
      calc.addEventListener('input', updateCalc);
      renumber();
      updateCalc();
    }

    form.addEventListener('submit', function (e) {
      if (calc && updateCalc() < 1) {
        e.preventDefault();
        calc.classList.add('is-error');
        if (!calc.querySelector('.calc__error')) {
          var p = document.createElement('p');
          p.className = 'calc__error small';
          p.setAttribute('role', 'alert');
          p.textContent = 'Enter a width and height to add this to your cart.';
          calc.appendChild(p);
        }
        calc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  /* ---------- price calculator page ----------
     Same materialLayout, billedSqft, roll widths and volume tiers as the product-page calculator. */
  document.querySelectorAll('[data-price-calc]').forEach(function (pc) {
    var film = pc.querySelector('[data-pc-film]');
    if (!film) return;
    var wEl = pc.querySelector('[data-pc-width]'), hEl = pc.querySelector('[data-pc-height]'), qEl = pc.querySelector('[data-pc-qty]');
    var noteEl = pc.querySelector('[data-pc-note]'), tierMsgEl = pc.querySelector('[data-pc-tier-msg]'), link = pc.querySelector('[data-pc-link]');
    function setText(sel, text) { var el = pc.querySelector(sel); if (el) el.textContent = text; }
    function updatePriceCalc() {
      var opt = film.options[film.selectedIndex];
      if (!opt) return;
      var R = Number(opt.getAttribute('data-roll-width')) || 60;
      var P = Number(opt.getAttribute('data-print-width')) || R;
      var price = Number(opt.getAttribute('data-price')) || 0;
      var w = num(wEl), h = num(hEl), n = Math.max(1, Math.round(num(qEl)) || 1);
      var L = materialLayout(w, h, n, R, P);
      var sqft = L ? billedSqft(L.billedSqIn) : 0;
      var listPrice = sqft * price;
      var tier = (WP.showTiers && sqft > 0) ? tierState(sqft).current : null;
      var total = tier ? Math.round(listPrice * (100 - tier.pct) / 100) : listPrice;
      setText('[data-pc-panels]', L ? (L.panels + (n > 1 ? ' per copy' : '')) : '0');
      setText('[data-pc-sqft]', fmtInt(sqft) + ' sq ft');
      setText('[data-pc-rate]', formatMoney(price));
      setText('[data-pc-tier]', tier ? tier.pct + '% off' : 'None');
      setText('[data-pc-total]', formatMoney(total));
      if (noteEl) { noteEl.textContent = L ? layoutNote(L, R, P) : ''; noteEl.hidden = !L; }
      if (tierMsgEl) {
        var msg = tierMessage(sqft);
        if (tier) msg = formatMoney(listPrice) + ' before the ' + tier.pct + '% volume discount. ' + msg;
        tierMsgEl.textContent = msg; tierMsgEl.hidden = !msg;
      }
      if (link) link.setAttribute('href', opt.getAttribute('data-url') || link.getAttribute('href'));
    }
    pc.addEventListener('input', updatePriceCalc);
    pc.addEventListener('change', updatePriceCalc);
    updatePriceCalc();
  });

  /* ---------- cart tier message ---------- */
  var cartForm = document.querySelector('[data-cart]');
  if (cartForm) {
    var tierEl = cartForm.querySelector('[data-cart-tier]');
    var total = Number(cartForm.getAttribute('data-total-sqft')) || 0;
    if (tierEl) { var m = tierMessage(total); tierEl.textContent = m; tierEl.hidden = !m; }
  }
})();
